import { render, staticRenderFns } from "./CompanyGroup.vue?vue&type=template&id=039b34b0&scoped=true"
import script from "./CompanyGroup.vue?vue&type=script&lang=js"
export * from "./CompanyGroup.vue?vue&type=script&lang=js"
import style0 from "./CompanyGroup.vue?vue&type=style&index=0&id=039b34b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b34b0",
  null
  
)

export default component.exports